/* eslint-disable eqeqeq */
import { useConstant } from '@wkda/funnel-components';
import { useInterpret } from '@xstate/react';
import { useCacheStorage } from '../../../formCache';
import { useCarleadFieldChangedTracking } from '../../../hooks/useCarleadFieldChangedTracking';
import { createFieldCategories, flowToArray, generateConfigForNormalMachine, transformInitialFlow } from '../../helpers/parseFlowToMachine';
import { createNormalFlowMachineConfig } from '../normalFlowMachineConfig';
import { useSplitFieldsMachineServices } from './services';
export function useSplitFieldsFlowService(_flow) {
  const flow = transformInitialFlow(_flow);
  const flowArray = flowToArray(_flow);
  const flowCategories = createFieldCategories(flowArray);
  const generatedStatesObjects = generateConfigForNormalMachine(flow, flowArray);
  const formMachine = createNormalFlowMachineConfig(generatedStatesObjects);
  const cache = useCacheStorage();
  const trackLeadFieldChanged = useCarleadFieldChangedTracking();
  const configuredMachine = formMachine.withConfig({
    actions: {
      // action used for general SELECT action from user
      // and prefill
      pushDataLayerEvent: function (_, event) {
        if (event && event.type === 'SELECT') if (event.selectionType) {
          trackLeadFieldChanged(event.fieldName, event.selectionType);
        }
      },

      // action only used for questionnaire fields data preload
      pushToDataLayerCache(_, __, _ref) {
        let {
          action
        } = _ref;
        trackLeadFieldChanged(action.fieldName, 'cache');
      }

    },
    services: { ...useSplitFieldsMachineServices()
    }
  }).withContext({ ...formMachine.context,
    dataFields: flowCategories.dataField,
    otherFields: flowCategories.normalField,
    questionnaireFields: flowCategories.questionnaireField,
    // DSB preload support
    // Feed with values object from dsb or empty
    // object if there is none or data does not match
    preloadedData: cache.getData()
  });
  const finalMachine = useConstant(() => configuredMachine);
  const machineInterpreter = useInterpret(finalMachine, {
    devTools: true
  });
  return machineInterpreter;
}